import React from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import CheckBox from "../../form/CheckBox";
import Select from "../../form/Select";
import TypeTextEditor from "../../form/TypeTextEditor";
import ColorPicker from "../../form/ColorPicker";
import ComponentField from "../../form/ComponentField";
import Figures from "../../form/Figures";

class ProgramForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-2">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-sm-8">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="name"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Név"
                        />
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <ColorPicker
                                name="color"
                                value={this.props.values.color}
                                isClearable={true}
                                label="Szín"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("color")}
                            />
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-3">
                        <Select
                            component="PointOfSale"
                            storeType="local"
                            label="Eladási hely"
                            name="pos"
                            objectValue={false}
                            labelKey="name"
                            value={this.props.values.pos}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("pos")}
                        />
                    </div>
                    <div className="col-md-3">
                        <TextInput
                            name="capacity"
                            type="number"
                            value={this.props.values.capacity}
                            label="Kapacitás/Max létszám"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("capacity")}
                        />
                    </div>
                    <div className="col-md-3">
                        <TextInput
                            name="reservation_limit"
                            type="number"
                            value={this.props.values.reservation_limit}
                            label="Fogalási maximum"
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("reservation_limit")}
                        />
                    </div>
                    <div className="col-md-3">
                        <Select
                            component="ProductCategory"
                            storeType="local"
                            label="Típus"
                            name="category"
                            objectValue={false}
                            labelKey="name"
                            value={this.props.values.category}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("category")}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-6">
                        <div className="row">
                            <div className="col-md-6">
                                <TextInput
                                    name="agefrom"
                                    type="number"
                                    value={this.props.values.agefrom}
                                    label="Életkortól"
                                    saveChanges={this.props.setFieldValue}
                                    {...this.props.getFieldProps("agefrom")}
                                />
                            </div>
                            <div className="col-md-6">
                                <TextInput
                                    name="ageto"
                                    type="number"
                                    value={this.props.values.ageto}
                                    label="Életkorig"
                                    saveChanges={this.props.setFieldValue}
                                    {...this.props.getFieldProps("ageto")}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <Select
                            component="ProgramType"
                            storeType="local"
                            label="Típus"
                            name="type"
                            objectValue={false}
                            value={this.props.values.type}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("type")}
                        />
                    </div>
                    <div className="col-md-3">
                        <div className="row">
                            <div className="col-md-6">
                                <label className="control-label">&nbsp;</label>
                                <CheckBox
                                    name="free"
                                    value={this.props.values.free}
                                    label="Ingyenes"
                                    saveChanges={this.props.setFieldValue}
                                    {...this.props.getFieldProps("free")}
                                />
                            </div>
                            <div className="col-md-6">
                                <label className="control-label">&nbsp;</label>
                                <CheckBox
                                    name="public"
                                    value={this.props.values.public}
                                    label="Publikus"
                                    saveChanges={this.props.setFieldValue}
                                    {...this.props.getFieldProps("public")}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <Figures name="figures" label="Képek" component={this.props.componentConfig.componentname} componentId={this.props.values[this.props.componentConfig.idfield]} />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="list_description"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Lista leírás"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="description"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Leírás"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="url"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Url"
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(ProgramForm);
